import React from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import { useStyles } from './Styles'
import logo from '../../../../../images/etax-logo.png'
import eFinance from '../../../../../images/e-finance.png'
import 'moment/locale/ar-ly'
import Moment from 'react-moment'

const PaymentReceiptPDFContent = ({ receiptDetails, userName, currentDate, locale }) => {
  const classes = useStyles()

  return (
    <div id={`pdfContent-${receiptDetails.receipt_number}`} className={classes.pdfContent}>
      <h3 align={'center'}><FormattedMessage id='PaymentReceipt.Dialog.Title'
                                             values={{ rec_num: receiptDetails.receipt_number }}/></h3>
      <div className='first-row'>
        <div className='dateWrapper'>
          <div className='itemWrapper'>
            <h5 className='itemLabel'>{<FormattedMessage id='PaymentHeader.receiptNumber'/>}</h5>
            <span className='itemValue'>{receiptDetails.receipt_number}</span>
          </div>
          <div className='itemWrapper'>
            <h5 className='itemLabel'>{<FormattedMessage id='PaymentHeader.requestNumber'/>}</h5>
            <span className='itemValue'>{receiptDetails.request_number}</span>
          </div>
          <div className='itemWrapper'>
            <h5 className='itemLabel'>{<FormattedMessage id='PaymentHeader.createDate'/>}</h5>
            <span className='itemValue'><Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                                                format="Do MMMM YYYY h:mm a">{receiptDetails.create_at}</Moment></span>
          </div>
          <div className='itemWrapper'>
            <h5 className='itemLabel'>{<FormattedMessage id='PaymentHeader.printDate'/>}</h5>
            <span className='itemValue'><Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                                                format="Do MMMM YYYY h:mm a">{currentDate}</Moment></span>
          </div>
        </div>
        <img src={logo} alt='e-finance logo' width={150}/>
      </div>
      <div className='data-row'>
        <div className='itemWrapper'>
          <h5 className='itemLabel'>{<FormattedMessage id='UserMenu.userName'/>}</h5>
          <span className='itemValue'>{userName}</span>
        </div>
        <div className='itemWrapper'>
          <h5 className='itemLabel'>{<FormattedMessage id='CompanyHeader.TaxpayerName'/>}</h5>
          <span className='itemValue'>{receiptDetails.taxpayer_name}</span>
        </div>
        <div className='itemWrapper'>
          <h5 className='itemLabel'>{<FormattedMessage id='CompanyHeader.CompanyName'/>}</h5>
          <span className='itemValue'>{receiptDetails.name}</span>
        </div>
        <div className='itemWrapper'>
          <h5 className='itemLabel'>{<FormattedMessage id='CompanyHeader.UniqueTaxId'/>}</h5>
          <span className='itemValue'>{receiptDetails.tax_id}</span>
        </div>
        <div className='itemWrapper'>
          <h5 className='itemLabel'>{<FormattedMessage id='PaymentHeader.climeType'/>}</h5>
          <span className='itemValue'>{receiptDetails.payment_tax_type}</span>
        </div>
        <div className='itemWrapper'>
          <h5 className='itemLabel'>{<FormattedMessage id='PaymentHeader.climeNumber'/>}</h5>
          <span className='itemValue'>{receiptDetails.payment_claim_number}</span>
        </div>
        <div className='itemWrapper'>
          <h5 className='itemLabel'>{<FormattedMessage id='PaymentHeader.receiptAmountPDF'/>}</h5>
          <span className='itemValue'><FormattedNumber value={receiptDetails.payment_claim_amount}/></span>
        </div>
        <div className='itemWrapper'>
          <h5 className='itemLabel'>{<FormattedMessage id='PaymentHeader.paymentTypePDF'/>}</h5>
          <span className='itemValue'>{receiptDetails.payment_type}</span>
        </div>
        <div className='itemWrapper'>
          <h5 className='itemLabel'>{<FormattedMessage id='PaymentHeader.taxPeriodFrom'/>}</h5>
          <span className='itemValue'><Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                                              format="Do MMMM YYYY h:mm a">{receiptDetails.payment_tax_period_from}</Moment></span>
        </div>
        <div className='itemWrapper'>
          <h5 className='itemLabel'>{<FormattedMessage id='PaymentHeader.taxPeriodTo'/>}</h5>
          <span className='itemValue'><Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                                              format="Do MMMM YYYY h:mm a">{receiptDetails.payment_tax_period_to}</Moment></span>
        </div>
        <div className='itemWrapper'>
          <h5 className='itemLabel'>{<FormattedMessage id='PaymentHeader.paymentItem'/>}</h5>
          <span className='itemValue'>{receiptDetails.payment_item}</span>
        </div>

        <div className='itemWrapper'>
          <h5 className='itemLabel'>{<FormattedMessage id='PaymentHeader.createDate'/>}</h5>
          <span className='itemValue'><Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                                              format="Do MMMM YYYY h:mm a">{receiptDetails.create_at}</Moment></span>
        </div>
      </div>
      <div className='last-row'>
        <h5><FormattedMessage id='footer.copyrights.poweredBy'/></h5>
        <img src={eFinance} alt='e-finance logo' width={230}/>
      </div>
      <br/>
      <br/>
    </div>
  )
}

export default PaymentReceiptPDFContent
